module.exports = __webpack_public_path__ + "static/media/sbi-bank-logo.ca928068.png";